import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'wen-icon-sort',
  templateUrl: './sort.component.html',
  styleUrls: ['./sort.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SortIconComponent {}
